import { jsx } from "react/jsx-runtime";
import { Carousel, StyledCarouselScrollContainer, token } from "@zillow/constellation";
import { event } from "@zillow/universal-analytics";
import { usePageProps, getCmsInfoForPage } from "@zillow/zrs-cms";
import PropTypes from "prop-types";
import "react";
import styled, { css } from "styled-components";
import { generateBlockList } from "../../components/BlockList/BlockList.esm.js";
const CarouselWrapper = /* @__PURE__ */ styled(Carousel).withConfig({
  displayName: "Carousel__CarouselWrapper",
  componentId: "sc-1nckztf-0"
})(["", "{", "}"], StyledCarouselScrollContainer, (props) => props.scrollOffsetMargin && css(["margin-left:-", "px;margin-right:-", "px;"], token(`spacing.${props.scrollOffset}`), token(`spacing.${props.scrollOffset}`)));
const BlockCarousel = (props) => {
  const {
    attrs,
    index,
    innerBlocks
  } = props;
  const pageProps = usePageProps();
  const {
    slideWidth = 340,
    slideGap = "sm",
    slideAlign = "start",
    scrollOffset = 0,
    includeSkipLink = true,
    enableSnap = false,
    scrollOffsetMargin = false,
    ...restAttrs
  } = attrs;
  const headingCarouselInnerBlocks = innerBlocks.find((block) => block.blockName === "constellation/carousel-v2-heading");
  const carouselSlidesInnerBlocks = innerBlocks.find((block) => block.blockName === "constellation/carousel-v2-slides");
  const handleNavigationEvent = (navigation) => {
    event({
      // https://dataportal.zillowgroup.net/event-registry/2048
      envelope: {
        event_type_id: "2048",
        event_type_version_id: "3",
        event_template_id: "126",
        event_template_version_id: "1"
        // Master ID: 2284.2.126.1
      },
      clickstream_trigger: {
        trigger_type_nm: "interaction",
        trigger_location_nm: "cms",
        trigger_source_nm: "cms_carousel",
        trigger_object_nm: "no_trigger_object"
      },
      semantic: {
        semantic_event_nm: "cms_click"
      },
      cms_info: {
        block_id: (attrs == null ? void 0 : attrs.id) || "",
        block_type_cd: "carousel",
        block_displayed_txt: navigation,
        ...getCmsInfoForPage(pageProps)
      }
    });
  };
  return /* @__PURE__ */ jsx(CarouselWrapper, { slideWidth, slideGap, slideAlign, scrollOffset, scrollOffsetMargin, includeSkipLink, enableSnap, heading: generateBlockList({
    blocks: headingCarouselInnerBlocks == null ? void 0 : headingCarouselInnerBlocks.innerBlocks
  }), onNextClick: () => {
    handleNavigationEvent("next");
  }, onPreviousClick: () => {
    handleNavigationEvent("previous");
  }, ...restAttrs, children: generateBlockList({
    blocks: carouselSlidesInnerBlocks == null ? void 0 : carouselSlidesInnerBlocks.innerBlocks
  }) }, index);
};
BlockCarousel.propTypes = {
  attrs: PropTypes.shape({
    slideWidth: PropTypes.string,
    slideGap: PropTypes.string,
    slideAlign: PropTypes.string,
    scrollOffset: PropTypes.string,
    includeSkipLink: PropTypes.bool,
    enableSnap: PropTypes.bool
  }),
  index: PropTypes.number
};
export {
  BlockCarousel as default
};
